import { useState, useEffect, useRef, useCallback } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { getFeaturedEvent, getAppSettings, addCartApi, getSearchEvent } from "../../api/api";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import "./homenew.css";
import Marquee from "react-fast-marquee";
import heroImg from "../../assets/Hero_section_desktop.webp";
import mobileHeroImg from "../../assets/image/Narayani_Mobile_hero.webp";
import studentOfferImg from "../../assets/image/studentoffer.webp";
import beat15Img from "../../assets/BEAT15.webp";
import imgSpbCharan from "../../assets/image/proformers/SPB_Charan.webp";
import imgAnuradhaSriram from "../../assets/image/proformers/Anuradha.webp";
import imgMano from "../../assets/image/proformers/Mano.webp";
import imgMukesh from "../../assets/image/proformers/Mukesh.webp";
import imgPriyankaNk from "../../assets/image/proformers/Priyanka.webp";
import imgHariPriya from "../../assets/image/proformers/Hari priya.webp";
import imgSamVishal from "../../assets/image/proformers/Sam vishal.webp";
import imgVmMahalingam from "../../assets/image/proformers/Vm_Mahalingam.webp";
import imgPriyaJerson from "../../assets/image/proformers/Priya Jerson.webp";
import imgPoojaVaidhiyanathan from "../../assets/image/proformers/Pooja Vaidhiyanathan.webp";
import imgKaushik from "../../assets/image/proformers/Kaushik.webp";
import imgAjayKrishna from "../../assets/image/proformers/Ajay Krishna.webp";
import imgKikiAnchor from "../../assets/image/proformers/kiki_Anchor.webp";
import imgManiAndBand from "../../assets/image/proformers/Mani and Band.webp";

// Artist Profile Images
import artAjayKrishna from "../../assets/image/artist/singer_ajay_krishna.webp";
import artAnuradhaSriram from "../../assets/image/artist/singer_anuradha_sriram.webp";
import artHariPriya from "../../assets/image/artist/singer_hari_priya.webp";
import artKaushik from "../../assets/image/artist/singer_kaushik.webp";
import artMahalingam from "../../assets/image/artist/singer_mahalingam.webp";
import artMukesh from "../../assets/image/artist/singer_mukesh.webp";
import artPooja from "../../assets/image/artist/singer_pooja.webp";
import artPriyaJerson from "../../assets/image/artist/singer_priya_jerson.webp";
import artPriyanka from "../../assets/image/artist/singer_priyanka.webp";
import artSamVishal from "../../assets/image/artist/singer_sam_vishal.webp";
import artSpbCharan from "../../assets/image/artist/singer_spb_charan.webp";
import dleLogo from "../../assets/image/dle_logo.webp";
import imgVVIP_Ticket from "../../assets/image/ticket_img/VVIP_TICKET_PASS.webp";
import imgVIP_Ticket from "../../assets/image/ticket_img/VIP_TICKET_PASS.webp";
import imgGolden_Ticket from "../../assets/image/ticket_img/GOLD_PASS_TICKET.webp";
import imgSilver_Ticket from "../../assets/image/ticket_img/Silver Pass.webp";
import imgMIP_Ticket from "../../assets/image/ticket_img/MIP pass.webp";

/* ===== SPONSORS ===== */
import sponsor1 from "../../assets/Sponors/Today's_ghee.webp";
import sponsor2 from "../../assets/Sponors/Roopakala copy.webp";
import sponsor3 from "../../assets/Sponors/PACHAIYAPPAS copy.webp";
import sponsor4 from "../../assets/Sponors/Narayani school.webp";
import sponsor5 from "../../assets/Sponors/Narayani Bhavan.webp";
import sponsor6 from "../../assets/Sponors/naidu_hall_img.webp";
import sponsor7 from "../../assets/Sponors/Darling copy.webp";
/* ===== PARTNERS ===== */
import partner1 from "../../assets/image/ticket_img/partners/Fortune (1).webp";
import partner2 from "../../assets/image/ticket_img/partners/Kanan&co.webp";
import partner3 from "../../assets/image/ticket_img/partners/Khanna (1).webp";
import partner4 from "../../assets/image/ticket_img/partners/maya call taxi.webp";
import partner5 from "../../assets/image/ticket_img/partners/Dhinamalar (1).webp";
import partner6 from "../../assets/image/ticket_img/partners/Minerva (1).webp";

/* ===== DECOR ASSETS ===== */

import decorIntroTopBorder from "../../assets/image/decor/intro_top_border.png";
import decorIntroLeft from "../../assets/image/decor/intro_left_instruments.png";
import decorIntroRight from "../../assets/image/decor/intro_right_instruments.png";
import decorRoyalBadge from "../../assets/image/decor/royal_music_badge.png";
import decorDividerLeft from "../../assets/image/decor/music_divider_left.png";
import decorDividerRight from "../../assets/image/decor/music_divider_right.png";
import decorNotesScatter from "../../assets/image/decor/music_notes_scatter.png";
import decorGoldenDivider from "../../assets/image/decor/golden_section_divider.png";
import decorCornerOrnament from "../../assets/image/decor/corner_ornament.png";



const sponsorsList = [sponsor1, sponsor2, sponsor3, sponsor4, sponsor5, sponsor6, sponsor7];
const partners = [partner1, partner2, partner3, partner4, partner5, partner6];

const HomeNew = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.accessToken;
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [featuredEvent, setFeaturedEvent] = useState([]);
  const [appSettings, setAppSettings] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [shuffledSponsors, setShuffledSponsors] = useState([]);
  const swiperRef = useRef(null);
  const performersSwiperRef = useRef(null);
  const rulesSwiperRef = useRef(null);
  const sponsorsSwiperRef = useRef(null);
  const partnersSwiperRef = useRef(null);

  const [selectedProfile, setSelectedProfile] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showCouponPopup, setShowCouponPopup] = useState(false);
  const [activeOffer, setActiveOffer] = useState("early"); // "student" or "early"

  const performers = [
    { name: "SPB Charan", role: "Classic Icon", color: "#7cb518", img: imgSpbCharan },
    { name: "Anuradha Sriram", role: "Powerhouse", color: "#00d4ff", img: imgAnuradhaSriram },
    { name: "Mano", role: "Legendary Voice", color: "#7cb518", img: imgMano },
    { name: "Mukesh", role: "Star Performer", color: "#ff2d7b", img: imgMukesh },
    { name: "Priyanka NK", role: "Super Singer Star", color: "#00d4ff", img: imgPriyankaNk },
    { name: "Hari Priya", role: "Viralvayyari", color: "#00d4ff", img: imgHariPriya },
    { name: "Sam Vishal", role: "Youth Sensation", color: "#7cb518", img: imgSamVishal },
    { name: "VM Mahalingam", role: "Folk King", color: "#00d4ff", img: imgVmMahalingam },
    { name: "Priya Jerson", role: "Vocal Talent", color: "#ff2d7b", img: imgPriyaJerson },
    { name: "Pooja Vaidhiyanathan", role: "Melody Queen", color: "#7cb518", img: imgPoojaVaidhiyanathan },
    { name: "Kaushik", role: "Sensational Voice", color: "#ff2d7b", img: imgKaushik },
    { name: "Ajay Krishna", role: "Rising Star", color: "#ff2d7b", img: imgAjayKrishna },
    { name: "KIKI Anchor", role: "Host & MC", color: "#7cb518", img: imgKikiAnchor },
    { name: "Mani and Band", role: "Live Ensemble", color: "#00d4ff", img: imgManiAndBand },
  ];

  const eventDate = new Date("2026-05-23T18:00:00");

  const updateCountdown = useCallback(() => {
    const now = new Date();
    const diff = eventDate - now;
    if (diff <= 0) {
      setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }
    setCountdown({
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Shuffle sponsors on mount
    setShuffledSponsors([...sponsorsList].sort(() => Math.random() - 0.5));
    fetchFeaturedEvent();
    fetchUpcomingEvents();
    fetchAppSettings();
    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    const lastShown = sessionStorage.getItem("couponPopupLastShown");
    const now = Date.now();
    const TWO_MINUTES = 2 * 60 * 1000;

    let popupTimer;
    if (!lastShown || (now - parseInt(lastShown)) > TWO_MINUTES) {
      popupTimer = setTimeout(() => {
        setShowCouponPopup(true);
        sessionStorage.setItem("couponPopupLastShown", Date.now().toString());
      }, 2500);
    }

    return () => {
      clearInterval(timer);
      if (popupTimer) clearTimeout(popupTimer);
    };
  }, [updateCountdown]);

  // useEffect(() => {
  //   if (showCouponPopup) {
  //     const offerInterval = setInterval(() => {
  //       setActiveOffer((prev) => (prev === "student" ? "early" : "student"));
  //     }, 5000);
  //     return () => clearInterval(offerInterval);
  //   }
  // }, [showCouponPopup]);

  /* ===== SCROLL-TRIGGERED ANIMATIONS DISABLED ===== */

  const [upcomingEvents, setUpcomingEvents] = useState([]);

  const fetchFeaturedEvent = async () => {
    try {
      const res = await getFeaturedEvent();
      setFeaturedEvent(res.data.info);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchUpcomingEvents = async () => {
    try {
      const res = await getSearchEvent({ sort: "Upcoming Events" }, 1, 100);
      if (res.status === 200 && Array.isArray(res.data.info.events)) {
        setUpcomingEvents(res.data.info.events);
      } else {
        setUpcomingEvents([]);
      }
    } catch (error) {
      console.error(error);
      setUpcomingEvents([]);
    }
  };

  const isSoldOutByPrice = (price) => {
    if (!Array.isArray(upcomingEvents)) return false;
    const event = upcomingEvents.find(e => e.price === price);
    // If no event matches this price, consider it SOLD OUT or unavailable
    if (!event) return true;
    return event.totalbooking >= event.maxbooking || event.isFeatured;
  };

  const fetchAppSettings = async () => {
    try {
      const response = await getAppSettings();
      if (response.status === 200) {
        setAppSettings(response.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const scrollToHighlights = () => {
    const el = document.getElementById("newhome-performers");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const pad = (n) => String(n).padStart(2, "0");

  const getFeatures = (price) => {
    switch (price) {
      case 500:
        return {
          color: "#8F99A2",
          items: [
            "Each ticket admits one person",
            "Seated zone (first come, first served basis)",
            "Children aged 5 years and above require a valid ticket",
            "Generic Audience Seating",
          ],
        };
      case 1000:
        return {
          color: "#FFB800",
          items: [
            "Each ticket admits one person",
            "Seated zone (first come, first served basis)",
            "Children aged 5 years and above require a valid ticket",
            "Good Proximal Distance with Led screen",
          ],
        };
      case 2500:
        return {
          color: "#00B2D4",
          items: [
            "Each ticket admits one person",
            "Seated zone (first come, first served basis)",
            "Children aged 5 years and above require a valid ticket",
            "Refreshments will be provided",
          ],
        };
      case 5000:
        return {
          color: "#EC6325",
          items: [
            "Each ticket admits one person",
            "Shared Lounge Seating (first come, first served basis)",
            "Children aged 5 years and above require a valid ticket",
            "Refreshments will be provided",
          ],
        };
      case 10000:
        return {
          color: "#8E44AD",
          items: [
            "Each ticket admits one person",
            "Premium Lounge Seating (first come, first served basis)",
            "Closest proximity to the stage",
            "Children aged 5 years and above require a valid ticket",
            "Refreshments will be provided",
          ],
        };
      default:
        return null;
    }
  };



  const handleBookNow = async (eventId) => {
    if (token) {
      try {
        const res = await addCartApi({ eventId: eventId, quantity: 1 }, token);
        navigate("/cart");
      } catch (error) {
        console.error("Add to cart error:", error);
        navigate("/cart");
      }
    } else {
      // For guest users, we now replace the cart with the new event to match backend behavior
      const guestCart = [{ eventId, quantity: 1 }];
      localStorage.setItem("guestCart", JSON.stringify(guestCart));
      navigate("/cart");
    }
  };

  /* ---------- TABS DATA ---------- */
  const tabs = [
    {
      icon: "📢",
      label: "RULES & SAFETY",
      title: "Rules & Safety",
      titleIcon: "📢",
      subtitle:
        "Your safety is our priority. By using a ticket, you agree to these conduct guidelines:",
      items: [
        { icon: "✔", type: "check", text: "Mandatory security checks and ID verification at all designated entrances." },
        { icon: "✔", type: "check", text: "Strict no-drug policy; violators will be evicted and face legal action under the NDPS Act." },
        { icon: "✔", type: "check", text: "The organizer reserves the right to eject anyone showing intoxicated or dangerous behavior." },
        { icon: "✔", type: "check", text: "Re-entry is strictly prohibited once the ticket is scanned." },
        { icon: "✔", type: "check", text: "Organizers are not liable for personal injury or loss of property." },
      ],
    },
    {
      icon: "🥤",
      label: "FOOD & BEVERAGES",
      title: "Food & Beverages",
      titleIcon: "🥤",
      subtitle:
        "To maintain a secure environment, the following items are strictly prohibited:",
      items: [
        { icon: "🚫", type: "warn", text: "No outside food, beverages, liquids, bottles, or cans are allowed." },
        { icon: "🚫", type: "warn", text: "Prohibited: Bags, lighters, matchboxes, tins, and flammable items." },
        { icon: "⚠️", type: "info", text: "Alcohol consumption is strictly limited to those of legal permissible age." },
      ],
    },
    {
      icon: "🚗",
      label: "PARKING",
      title: "Parking",
      titleIcon: "🚗",
      subtitle:
        "Dedicated parking zones are available at Golden Ground. Please follow the instructions of our traffic marshals.",
      items: [],
      note: "Note: Parking fees are non-refundable, and the organizer is not responsible for any loss or damage to vehicles.",
    },
    {
      icon: "🎫",
      label: "TERMS & PRICING",
      title: "Terms & Pricing",
      titleIcon: "🎫",
      subtitle:
        "All ticket purchases are final. Please review the terms before booking:",
      items: [
        { icon: "✔", type: "check", text: "Tickets are non-refundable and non-transferable." },
        { icon: "✔", type: "check", text: "Prices are inclusive of all applicable taxes and convenience fees." },
        { icon: "✔", type: "check", text: "Children under 5 years can enter free with a valid guardian ticket." },
        { icon: "✔", type: "check", text: "The organizer reserves the right to change the event schedule without prior notice." },
      ],
    },
  ];

  const currentTab = tabs[activeTab];

  return (
    <>
      <div className="newhome">
      {/* ===== HERO ===== */}
      <section className="newhome-hero">
        <picture>
          <source media="(max-width: 768px)" srcSet={mobileHeroImg} />
          <img src={isMobile ? mobileHeroImg : heroImg} alt="Geetham Sangeetham – OG Vibe Live" className="newhome-hero-img" loading="eager" fetchPriority="high" />
        </picture>
        
      </section>

      {/* ===== COUNTDOWN BAR ===== */}
      <section className="newhome-countdown" data-animate="fade-up">
        <div className="newhome-countdown-inner">
          <div className="newhome-countdown-timers">
            <div className="newhome-countdown-unit">
              <div className="newhome-countdown-circle pink">
                <span className="newhome-countdown-num">{pad(countdown.days)}</span>
              </div>
              <span className="newhome-countdown-label">DAYS</span>
            </div>
            <span className="newhome-countdown-sep">:</span>
            <div className="newhome-countdown-unit">
              <div className="newhome-countdown-circle cyan">
                <span className="newhome-countdown-num">{pad(countdown.hours)}</span>
              </div>
              <span className="newhome-countdown-label">HRS</span>
            </div>
            <span className="newhome-countdown-sep">:</span>
            <div className="newhome-countdown-unit">
              <div className="newhome-countdown-circle lime">
                <span className="newhome-countdown-num">{pad(countdown.minutes)}</span>
              </div>
              <span className="newhome-countdown-label">MIN</span>
            </div>
            <span className="newhome-countdown-sep">:</span>
            <div className="newhome-countdown-unit">
              <div className="newhome-countdown-circle white">
                <span className="newhome-countdown-num">{pad(countdown.seconds)}</span>
              </div>
              <span className="newhome-countdown-label">SEC</span>
            </div>
          </div>

          <div className="newhome-countdown-info">
            <div className="newhome-countdown-info-row">
              <span className="newhome-countdown-info-icon pink-icon">📅</span>
              <div>
                <div className="newhome-countdown-info-main">23 MAY 2026</div>
                <div className="newhome-countdown-info-sub">@ 6:00 PM ONWARDS</div>
              </div>
            </div>
            <div className="newhome-countdown-info-row">
              <span className="newhome-countdown-info-icon lime-icon">📍</span>
              <div>
                <div className="newhome-countdown-info-main">GOLDEN GROUND</div>
                <div className="newhome-countdown-info-sub">VELLORE - 632055</div>
              </div>
            </div>
          </div>

          <button className="newhome-countdown-btn" onClick={() => {
            const el = document.getElementById('newhome-pricing-grid');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}>
            GET TICKETS
          </button>
        </div>
      </section>

      {/* ===== PRICING ===== */}
      <section className="newhome-pricing" id="newhome-pricing" data-animate="fade-up">
        <img src={decorGoldenDivider} alt="" className="newhome-decor-golden-divider" />
        <h2 className="newhome-pricing-title">Pricing</h2>
        <div className="newhome-pricing-divider"></div>
        <p className="newhome-pricing-desc">
          Choose the perfect pass for your Sangeetham experience. Secure your spot before they sell out.
        </p>

        <div className="newhome-pricing-grid" id="newhome-pricing-grid">
          {/* Silver Pass */}
          <div className={`newhome-pricing-card newhome-pricing-card--silver ${isSoldOutByPrice(500) ? "sold-out" : ""}`}>
            <div className="newhome-pricing-card-accent"></div>
            {isSoldOutByPrice(500) ? (
              <span className="newhome-pricing-badge" style={{ background: '#555' }}>SOLD OUT</span>
            ) : (
              <span className="newhome-pricing-badge">SILVER</span>
            )}
            <div className="newhome-pricing-card-header">
              <img 
                src={imgSilver_Ticket} 
                alt="Silver Ticket" 
                className="newhome-pricing-ticket-img" 
                loading="lazy" 
                width="300" 
                height="420" 
                style={isSoldOutByPrice(500) ? { filter: 'grayscale(1) opacity(0.7)' } : {}}
              />
                <div className="newhome-pricing-tier-label silver" style={isSoldOutByPrice(500) ? { color: '#999' } : {}}>Silver Pass</div>
                <div className="newhome-pricing-amount" style={isSoldOutByPrice(500) ? { color: '#999' } : {}}>
                  <span className="newhome-pricing-currency">₹</span>500
                </div>
                <div className="newhome-pricing-per" style={isSoldOutByPrice(500) ? { color: '#bbb' } : {}}>per person</div>
            </div>
            <div className="newhome-pricing-card-perforation"></div>
            <div className="newhome-pricing-card-body">
              <ul className="newhome-pricing-features">
                <li>
                  <span className="newhome-pricing-check silver">✓</span>
                  <span>Each ticket admits one person</span>
                </li>
                <li>
                  <span className="newhome-pricing-check silver">✓</span>
                  <span>Seated zone (first come, first served basis)</span>
                </li>
                <li>
                  <span className="newhome-pricing-check silver">✓</span>
                  <span>Children aged 5 years and above require a valid ticket</span>
                </li>
                <li>
                  <span className="newhome-pricing-check silver">✓</span>
                  <span>Generic Audience Seating</span>
                </li>
              </ul>
            </div>
            <div className="newhome-pricing-card-footer">
              <button 
                className="newhome-pricing-btn newhome-pricing-btn--silver" 
                onClick={() => handleBookNow("69f44598bc01bb98caaf50c6")}
                disabled={isSoldOutByPrice(500)}
                style={isSoldOutByPrice(500) ? { background: '#999', borderColor: '#999', cursor: 'not-allowed', color: '#fff' } : {}}
              >
                {isSoldOutByPrice(500) ? "SOLD OUT" : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /></svg>
                    BOOK NOW
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Gold Pass */}
          <div className={`newhome-pricing-card newhome-pricing-card--gold ${isSoldOutByPrice(1000) ? "sold-out" : ""}`}>
            <div className="newhome-pricing-card-accent"></div>
            {isSoldOutByPrice(1000) ? (
              <span className="newhome-pricing-badge" style={{ background: '#555' }}>SOLD OUT</span>
            ) : (
              <span className="newhome-pricing-badge">GOLD</span>
            )}
            <div className="newhome-pricing-card-header">
              <img 
                src={imgGolden_Ticket} 
                alt="Gold Ticket" 
                className="newhome-pricing-ticket-img" 
                loading="lazy" 
                width="300" 
                height="420" 
                style={isSoldOutByPrice(1000) ? { filter: 'grayscale(1) opacity(0.7)' } : {}}
              />
                <div className="newhome-pricing-tier-label gold" style={isSoldOutByPrice(1000) ? { color: '#999' } : {}}>Gold Pass</div>
                <div className="newhome-pricing-amount" style={isSoldOutByPrice(1000) ? { color: '#999' } : {}}>
                  <span className="newhome-pricing-currency">₹</span>1,000
                </div>
                <div className="newhome-pricing-per" style={isSoldOutByPrice(1000) ? { color: '#bbb' } : {}}>per person</div>
            </div>
            <div className="newhome-pricing-card-perforation"></div>
            <div className="newhome-pricing-card-body">
              <ul className="newhome-pricing-features">
                <li>
                  <span className="newhome-pricing-check gold">✓</span>
                  <span>Each ticket admits one person</span>
                </li>
                <li>
                  <span className="newhome-pricing-check gold">✓</span>
                  <span>Seated zone (first come, first served basis)</span>
                </li>
                <li>
                  <span className="newhome-pricing-check gold">✓</span>
                  <span>Children aged 5 years and above require a valid ticket</span>
                </li>
                <li>
                  <span className="newhome-pricing-check gold">✓</span>
                  <span>Good Proximal Distance with Led screen</span>
                </li>
              </ul>
            </div>
            <div className="newhome-pricing-card-footer">
              <button 
                className="newhome-pricing-btn newhome-pricing-btn--gold" 
                onClick={() => handleBookNow("69f22a65dded02a7633f7e99")}
                disabled={isSoldOutByPrice(1000)}
                style={isSoldOutByPrice(1000) ? { background: '#999', borderColor: '#999', cursor: 'not-allowed', color: '#fff' } : {}}
              >
                {isSoldOutByPrice(1000) ? "SOLD OUT" : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /></svg>
                    BOOK NOW
                  </>
                )}
              </button>
            </div>
          </div>

          {/* VIP Pass — FEATURED */}
          <div className={`newhome-pricing-card newhome-pricing-card--vip featured ${isSoldOutByPrice(2500) ? "sold-out" : ""}`}>
            <div className="newhome-pricing-card-accent"></div>
            {isSoldOutByPrice(2500) ? (
              <span className="newhome-pricing-badge" style={{ background: '#555' }}>SOLD OUT</span>
            ) : (
              <span className="newhome-pricing-badge featured-badge">★ POPULAR</span>
            )}
            <div className="newhome-pricing-card-header">
              <img 
                src={imgVIP_Ticket} 
                alt="VIP Ticket" 
                className="newhome-pricing-ticket-img" 
                loading="lazy" 
                width="300" 
                height="420" 
                style={isSoldOutByPrice(2500) ? { filter: 'grayscale(1) opacity(0.7)' } : {}}
              />
                <div className="newhome-pricing-tier-label vip" style={isSoldOutByPrice(2500) ? { color: '#999' } : {}}>VIP Pass</div>
                <div className="newhome-pricing-amount" style={isSoldOutByPrice(2500) ? { color: '#999' } : {}}>
                  <span className="newhome-pricing-currency">₹</span>2,500
                </div>
                <div className="newhome-pricing-per" style={isSoldOutByPrice(2500) ? { color: '#bbb' } : {}}>per person</div>
            </div>
            <div className="newhome-pricing-card-perforation"></div>
            <div className="newhome-pricing-card-body">
              <ul className="newhome-pricing-features">
                <li>
                  <span className="newhome-pricing-check vip">✓</span>
                  <span>Each ticket admits one person</span>
                </li>
                <li>
                  <span className="newhome-pricing-check vip">✓</span>
                  <span>Seated zone (first come, first served basis)</span>
                </li>
                <li>
                  <span className="newhome-pricing-check vip">✓</span>
                  <span>Children aged 5 years and above require a valid ticket</span>
                </li>
                <li>
                  <span className="newhome-pricing-check vip">✓</span>
                  <span>Refreshments will be provided</span>
                </li>
              </ul>
            </div>
            <div className="newhome-pricing-card-footer">
              <button 
                className="newhome-pricing-btn newhome-pricing-btn--vip" 
                onClick={() => handleBookNow("69f22b10dded02a7633f7ec8")}
                disabled={isSoldOutByPrice(2500)}
                style={isSoldOutByPrice(2500) ? { background: '#999', borderColor: '#999', cursor: 'not-allowed', color: '#fff' } : {}}
              >
                {isSoldOutByPrice(2500) ? "SOLD OUT" : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /></svg>
                    BOOK NOW
                  </>
                )}
              </button>
            </div>
          </div>

          {/* VVIP Pass */}
          <div className={`newhome-pricing-card newhome-pricing-card--vvip ${isSoldOutByPrice(5000) ? "sold-out" : ""}`}>
            <div className="newhome-pricing-card-accent"></div>
            {isSoldOutByPrice(5000) ? (
              <span className="newhome-pricing-badge" style={{ background: '#555' }}>SOLD OUT</span>
            ) : (
              <span className="newhome-pricing-badge" style={{ background: '#EC6325' }}>VVIP</span>
            )}
            <div className="newhome-pricing-card-header">
              <img 
                src={imgVVIP_Ticket} 
                alt="VVIP Ticket" 
                className="newhome-pricing-ticket-img" 
                loading="lazy" 
                width="300" 
                height="420" 
                style={isSoldOutByPrice(5000) ? { filter: 'grayscale(1) opacity(0.7)' } : {}}
              />
                <div className="newhome-pricing-tier-label vvip" style={isSoldOutByPrice(5000) ? { color: '#999' } : {}}>VVIP Pass</div>
                <div className="newhome-pricing-amount" style={isSoldOutByPrice(5000) ? { color: '#999' } : {}}>
                  <span className="newhome-pricing-currency">₹</span>5,000
                </div>
                <div className="newhome-pricing-per" style={isSoldOutByPrice(5000) ? { color: '#bbb' } : {}}>per person</div>
            </div>
            <div className="newhome-pricing-card-perforation"></div>
            <div className="newhome-pricing-card-body">
              <ul className="newhome-pricing-features">
                <li>
                  <span className="newhome-pricing-check vvip" style={isSoldOutByPrice(5000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(5000) ? { color: '#999' } : {}}>Each ticket admits one person</span>
                </li>
                <li>
                  <span className="newhome-pricing-check vvip" style={isSoldOutByPrice(5000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(5000) ? { color: '#999' } : {}}>Shared Lounge Seating (first come, first served basis)</span>
                </li>
                <li>
                  <span className="newhome-pricing-check vvip" style={isSoldOutByPrice(5000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(5000) ? { color: '#999' } : {}}>Children aged 5 years and above require a valid ticket</span>
                </li>
                <li>
                  <span className="newhome-pricing-check vvip" style={isSoldOutByPrice(5000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(5000) ? { color: '#999' } : {}}>Refreshments will be provided</span>
                </li>
              </ul>
            </div>
            <div className="newhome-pricing-card-footer">
              <button 
                className="newhome-pricing-btn newhome-pricing-btn--vvip" 
                onClick={() => handleBookNow("69f22b7b6eb9cf5330b69295")}
                disabled={isSoldOutByPrice(5000)}
                style={isSoldOutByPrice(5000) ? { background: '#999', borderColor: '#999', cursor: 'not-allowed', color: '#fff' } : {}}
              >
                {isSoldOutByPrice(5000) ? "SOLD OUT" : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /></svg>
                    BOOK NOW
                  </>
                )}
              </button>
            </div>
          </div>

          {/* MIP Pass */}
          <div className={`newhome-pricing-card newhome-pricing-card--mip ${isSoldOutByPrice(10000) ? "sold-out" : ""}`}>
            <div className="newhome-pricing-card-accent"></div>
            {isSoldOutByPrice(10000) ? (
              <span className="newhome-pricing-badge" style={{ background: '#555' }}>SOLD OUT</span>
            ) : (
              <span className="newhome-pricing-badge">MIP</span>
            )}
            <div className="newhome-pricing-card-header">
              <img 
                src={imgMIP_Ticket} 
                alt="MIP Ticket" 
                className="newhome-pricing-ticket-img" 
                loading="lazy" 
                width="300" 
                height="420" 
                style={isSoldOutByPrice(10000) ? { filter: 'grayscale(1) opacity(0.7)' } : {}}
              />
                <div className="newhome-pricing-tier-label mip" style={isSoldOutByPrice(10000) ? { color: '#999' } : {}}>MIP Pass</div>
                <div className="newhome-pricing-amount" style={isSoldOutByPrice(10000) ? { color: '#999' } : {}}>
                  <span className="newhome-pricing-currency">₹</span>10,000
                </div>
                <div className="newhome-pricing-per" style={isSoldOutByPrice(10000) ? { color: '#bbb' } : {}}>per person</div>
            </div>
            <div className="newhome-pricing-card-perforation"></div>
            <div className="newhome-pricing-card-body">
              <ul className="newhome-pricing-features">
                <li>
                  <span className="newhome-pricing-check mip" style={isSoldOutByPrice(10000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(10000) ? { color: '#999' } : {}}>Each ticket admits one person</span>
                </li>
                <li>
                  <span className="newhome-pricing-check mip" style={isSoldOutByPrice(10000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(10000) ? { color: '#999' } : {}}>Premium Lounge Seating (first come, first served basis)</span>
                </li>
                <li>
                  <span className="newhome-pricing-check mip" style={isSoldOutByPrice(10000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(10000) ? { color: '#999' } : {}}>Closest proximity to the stage</span>
                </li>
                <li>
                  <span className="newhome-pricing-check mip" style={isSoldOutByPrice(10000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(10000) ? { color: '#999' } : {}}>Children aged 5 years and above require a valid ticket</span>
                </li>
                <li>
                  <span className="newhome-pricing-check mip" style={isSoldOutByPrice(10000) ? { background: '#999' } : {}}>✓</span>
                  <span style={isSoldOutByPrice(10000) ? { color: '#999' } : {}}>Refreshments will be provided</span>
                </li>
              </ul>
            </div>
            <div className="newhome-pricing-card-footer">
              <button 
                className="newhome-pricing-btn newhome-pricing-btn--mip" 
                onClick={() => handleBookNow("69f22bc0dded02a7633f7f06")}
                disabled={isSoldOutByPrice(10000)}
                style={isSoldOutByPrice(10000) ? { background: '#999', borderColor: '#999', cursor: 'not-allowed', color: '#fff' } : {}}
              >
                {isSoldOutByPrice(10000) ? "SOLD OUT" : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /></svg>
                    BOOK NOW
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* ===== EVENT INTRO ===== */}
      <section className="newhome-intro" data-animate="fade-up">
        <img src={decorIntroTopBorder} alt="" className="newhome-decor-intro-top-border" loading="lazy" width="600" height="40" />
        <img src={decorIntroLeft} alt="" className="newhome-decor-intro-left" loading="lazy" width="150" height="300" />
        <img src={decorIntroRight} alt="" className="newhome-decor-intro-right" loading="lazy" width="150" height="300" />
        <img src={decorRoyalBadge} alt="" className="newhome-decor-royal-badge" loading="lazy" width="120" height="120" />
        <h2 className="newhome-intro-title">Geetham Sangeetham – OG Vibe Live</h2>
        <div className="newhome-intro-divider"></div>
        <p className="newhome-intro-text">
          Get ready, Vellore! For the very first time, <strong>Geetham Sangeetham</strong> brings an electrifying musical experience to your city. Step into a night filled with nostalgia, soulful melodies, and high-energy performances by renowned artists, all coming together to celebrate the magic of music.
        </p>
        <p className="newhome-intro-text">
          Set under a vibrant live stage atmosphere, this concert promises an unforgettable blend of classic hits and contemporary vibes that will keep you singing along all night.
        </p>
        <p className="newhome-intro-highlight">Mark your calendar – May 23, 2026.</p>
        <p className="newhome-intro-tagline">An experience you don't just watch.. but feel.</p>
        <div className="newhome-intro-divider"></div>
        <div className="newhome-intro-cta">
          <span className="newhome-intro-cta-text">Check it out</span>
          <button className="newhome-intro-scroll-btn" onClick={scrollToHighlights}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </div>
      </section>

      {/* ===== EVENT PERFORMERS ===== */}
      <section className="newhome-performers" id="newhome-performers" data-animate="fade-up">
        <div className="newhome-decor-performers-heading">
          <img src={decorDividerLeft} alt="" className="newhome-decor-divider-left" />
          <h2 className="newhome-performers-title">EVENT PERFORMERS</h2>
          <img src={decorDividerRight} alt="" className="newhome-decor-divider-right" />
        </div>
        <div className="newhome-performers-divider" id="newhome-performers-divider"></div>



        <Swiper
          slidesPerView={5}
          spaceBetween={20}
          loop={true}
          speed={4000}
          autoplay={{
            delay: 0,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            1400: { slidesPerView: 5, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 18 },
            768: { slidesPerView: 3, spaceBetween: 16 },
            480: { slidesPerView: 2.2, spaceBetween: 12 },
            0: { slidesPerView: 1.5, spaceBetween: 10 },
          }}
          modules={[Navigation, Autoplay]}
          className="newhome-performers-swiper"
          id="newhome-performers-swiper"
          onSwiper={(swiper) => { performersSwiperRef.current = swiper; }}
        >
          {performers.map((performer, index) => (
            <SwiperSlide key={index}>
              <div className="newhome-performer-card">
                <div className="newhome-performer-img" style={{ borderTopColor: performer.color }}>
                  <img src={performer.img} alt={performer.name} loading="lazy" width="280" height="350" style={{ objectPosition: performer.objectPosition || "top center" }} />
                </div>
                <div className="newhome-performer-info">
                  <div className="newhome-performer-name">{performer.name}</div>
                  <div className="newhome-performer-role" style={{ color: performer.color }}>{performer.role}</div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="newhome-performers-view-all">
          <button 
            className="view-profiles-btn" 
            onClick={() => setShowProfileModal(true)}
          >
            VIEW PROFILES
          </button>
        </div>


      </section>

      {/* ===== HIGHLIGHTS ===== */}
      <section className="newhome-highlights" id="newhome-highlights" data-animate="scale-in" style={{ backgroundImage: `url(${decorNotesScatter})`, backgroundSize: '600px', backgroundRepeat: 'repeat', backgroundBlendMode: 'soft-light' }}>
        <div className="newhome-highlights-header">
          <span className="newhome-highlights-label">WHAT WE OFFER</span>
          <h2 className="newhome-highlights-title">Event Highlights</h2>
          <p className="newhome-highlights-desc">
            Everything you need for a perfect night — seamless entry, great food, safe parking, and an incredible atmosphere.
          </p>
        </div>
        <div className="newhome-highlights-grid">
          {/* Tickets */}
          <div className="newhome-highlight-card" style={{ "--card-accent": "#EC6325" }}>
            <div className="newhome-highlight-card-num">01</div>
            <div className="newhome-highlight-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#EC6325" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg>
            </div>
            <div className="newhome-highlight-card-title">Tickets</div>
            <div className="newhome-highlight-card-desc">
              Easy online booking and secure digital passes for swift entry at the gates.
            </div>
          </div>
          {/* Food & Drinks */}
          <div className="newhome-highlight-card" style={{ "--card-accent": "#e53935" }}>
            <div className="newhome-highlight-card-num">02</div>
            <div className="newhome-highlight-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e53935" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1" /><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" /><line x1="6" y1="1" x2="6" y2="4" /><line x1="10" y1="1" x2="10" y2="4" /><line x1="14" y1="1" x2="14" y2="4" /></svg>
            </div>
            <div className="newhome-highlight-card-title">Food & Drinks</div>
            <div className="newhome-highlight-card-desc">
              Premium food stalls and refreshing beverages available on-site all night.
            </div>
          </div>
          {/* Parking */}
          <div className="newhome-highlight-card" style={{ "--card-accent": "#4CAF50" }}>
            <div className="newhome-highlight-card-num">03</div>
            <div className="newhome-highlight-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9 17V7h4a3 3 0 0 1 0 6H9" /></svg>
            </div>
            <div className="newhome-highlight-card-title">Parking</div>
            <div className="newhome-highlight-card-desc">
              Ample, secure parking space located right beside the main venue area.
            </div>
          </div>
          {/* Incredible Crowd */}
          <div className="newhome-highlight-card" style={{ "--card-accent": "#1976D2" }}>
            <div className="newhome-highlight-card-num">04</div>
            <div className="newhome-highlight-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1976D2" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
            </div>
            <div className="newhome-highlight-card-title">Incredible Crowd</div>
            <div className="newhome-highlight-card-desc">
              Join thousands of passionate music lovers for an unforgettable celebration.
            </div>
          </div>
        </div>
      </section>

      {/* ===== SPONSORS SECTION ===== */}
      <section className="newhome-sponsors" data-animate="fade-up">
        {/* Royal Decor Assets */}
        <img src={decorCornerOrnament} className="newhome-decor-corner-tl" alt="" loading="lazy" width="80" height="80" />
        <img src={decorCornerOrnament} className="newhome-decor-corner-br" alt="" loading="lazy" width="80" height="80" />

        <div className="newhome-sponsors-container">
          <h2 className="newhome-section-title">Our Sponsors</h2>

          <div className="newhome-sponsors-swiper-wrapper">
            <Swiper
              slidesPerView={4}
              spaceBetween={30}
              loop={true}
              speed={6000}
              autoplay={{
                delay: 0,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
              }}
              breakpoints={{
                1200: { slidesPerView: 4, spaceBetween: 30 },
                1024: { slidesPerView: 3, spaceBetween: 24 },
                768: { slidesPerView: 2, spaceBetween: 20 },
                0: { slidesPerView: 1.3, spaceBetween: 20 },
              }}
              modules={[Navigation, Autoplay]}
              className="newhome-sponsors-swiper"
              onSwiper={(swiper) => { sponsorsSwiperRef.current = swiper; }}
            >
              {shuffledSponsors.map((imgSrc, idx) => (
                <SwiperSlide key={idx}>
                  <div className="newhome-sponsor-card">
                    <div className="newhome-sponsor-card-inner">
                      <img
                        src={imgSrc}
                        alt="Sponsor"
                        className="newhome-sponsor-image"
                        loading="lazy"
                        width="150"
                        height="150"
                        style={{
                          transform: 'none'
                        }}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>


          </div>
        </div>
      </section>

      {/* ===== FEATURED EVENTS ===== */}
      <section className="newhome-events" data-animate="fade-left">
        <div className="newhome-events-header">
          <h2 className="newhome-events-title">Upcoming Events</h2>
          <div className="newhome-events-divider"></div>
          <p className="newhome-events-desc">
            Don't miss out on the most exciting happenings near you!
          </p>
        </div>

        <div className="newhome-single-event-container">
          <div className="newhome-event-card">
            <div className="newhome-event-img-wrapper">
              <picture>
                <source media="(max-width: 768px)" srcSet={mobileHeroImg} />
                <img
                  className="newhome-event-img"
                  src={isMobile ? mobileHeroImg : heroImg}
                  alt="Geetham Sangeetham"
                  loading="lazy"
                />
              </picture>
            </div>
            <div className="newhome-event-body">
              <div className="newhome-event-name">Geetham Sangeetham</div>
              <div className="newhome-event-location">
                <svg
                  width="14"
                  height="18"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0, marginTop: "2px" }}
                >
                  <path
                    d="M8 0C3.85813 0 0.5 3.35813 0.5 7.5C0.5 9.13094 1.03469 10.6275 1.92344 11.8531C1.93938 11.8825 1.94187 11.9153 1.96 11.9434L6.96 19.4434C7.19188 19.7913 7.5825 20 8 20C8.4175 20 8.80812 19.7913 9.04 19.4434L14.04 11.9434C14.0584 11.9153 14.0606 11.8825 14.0766 11.8531C14.9653 10.6275 15.5 9.13094 15.5 7.5C15.5 3.35813 12.1419 0 8 0ZM8 10C6.61937 10 5.5 8.88062 5.5 7.5C5.5 6.11937 6.61937 5 8 5C9.38062 5 10.5 6.11937 10.5 7.5C10.5 8.88062 9.38062 10 8 10Z"
                    fill="#EC6325"
                  />
                </svg>
                <span className="newhome-event-location-text">
                  Golden Ground, Vellore, Tamil Nadu
                </span>
              </div>

              <div className="newhome-event-btn">
                <button
                  onClick={() => navigate("/event")}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /></svg>
                  GET TICKET
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== RULES & INFO ===== */}
      <section className="newhome-rules" data-animate="fade-up">
        <div className="newhome-rules-container">
          <div className="newhome-rules-sidebar-wrapper">
            {isMobile && (
              <button 
                className="rules-sidebar-nav-btn prev" 
                onClick={() => {
                  const container = document.querySelector('.newhome-rules-sidebar');
                  if (container) container.scrollBy({ left: -100, behavior: 'smooth' });
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
              </button>
            )}
            <div className="newhome-rules-sidebar">
              {tabs.map((tab, idx) => (
                <div
                  key={idx}
                  className={`newhome-rules-tab ${activeTab === idx ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab(idx);
                    if (isMobile && rulesSwiperRef.current) {
                      rulesSwiperRef.current.slideTo(idx);
                    }
                  }}
                >
                  <span className="newhome-rules-tab-icon">{tab.icon}</span>
                  {tab.label}
                </div>
              ))}
            </div>
            {isMobile && (
              <button 
                className="rules-sidebar-nav-btn next" 
                onClick={() => {
                  const container = document.querySelector('.newhome-rules-sidebar');
                  if (container) container.scrollBy({ left: 100, behavior: 'smooth' });
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
              </button>
            )}
          </div>
          <div className="newhome-rules-content">
            {isMobile ? (
              <div className="newhome-rules-swiper-container">
                
                <Swiper
                  spaceBetween={30}
                  slidesPerView={1}
                  onSlideChange={(swiper) => setActiveTab(swiper.activeIndex)}
                  onSwiper={(swiper) => {
                    rulesSwiperRef.current = swiper;
                    swiper.slideTo(activeTab);
                  }}
                  className="rules-mobile-swiper"
                >
                  {tabs.map((tab, idx) => (
                    <SwiperSlide key={idx}>
                      <h3 className="newhome-rules-content-title">
                        <div className="newhome-rules-content-title-left">
                          <span className="newhome-rules-content-title-icon">
                            {tab.titleIcon}
                          </span>
                          {tab.title}
                        </div>
                        <div className="rules-header-nav">
                          <button 
                            className="rules-nav-btn prev" 
                            disabled={activeTab === 0}
                            onClick={(e) => {
                              e.stopPropagation();
                              const newIdx = Math.max(0, activeTab - 1);
                              setActiveTab(newIdx);
                              if (rulesSwiperRef.current) rulesSwiperRef.current.slideTo(newIdx);
                            }}
                          >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                          </button>
                          <button 
                            className="rules-nav-btn next" 
                            disabled={activeTab === tabs.length - 1}
                            onClick={(e) => {
                              e.stopPropagation();
                              const newIdx = Math.min(tabs.length - 1, activeTab + 1);
                              setActiveTab(newIdx);
                              if (rulesSwiperRef.current) rulesSwiperRef.current.slideTo(newIdx);
                            }}
                          >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                          </button>
                        </div>
                      </h3>
                      <p className="newhome-rules-content-subtitle">
                        {tab.subtitle}
                      </p>
                      {tab.items.length > 0 && (
                        <ul className="newhome-rules-list">
                          {tab.items.map((item, itemIdx) => (
                            <li key={itemIdx}>
                              <span className={`newhome-rules-list-icon ${item.type}`}>
                                {item.icon}
                              </span>
                              {item.text}
                            </li>
                          ))}
                        </ul>
                      )}
                      {tab.note && (
                        <p className="newhome-rules-note">{tab.note}</p>
                      )}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ) : (
              <>
                <h3 className="newhome-rules-content-title">
                  <div className="newhome-rules-content-title-left">
                    <span className="newhome-rules-content-title-icon">
                      {currentTab.titleIcon}
                    </span>
                    {currentTab.title}
                  </div>
                  <div className="rules-header-nav">
                    <button 
                      className="rules-nav-btn prev" 
                      disabled={activeTab === 0}
                      onClick={() => setActiveTab(prev => Math.max(0, prev - 1))}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                    </button>
                    <button 
                      className="rules-nav-btn next" 
                      disabled={activeTab === tabs.length - 1}
                      onClick={() => setActiveTab(prev => Math.min(tabs.length - 1, prev + 1))}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                    </button>
                  </div>
                </h3>
                <p className="newhome-rules-content-subtitle">
                  {currentTab.subtitle}
                </p>
                {currentTab.items.length > 0 && (
                  <ul className="newhome-rules-list">
                    {currentTab.items.map((item, idx) => (
                      <li key={idx}>
                        <span className={`newhome-rules-list-icon ${item.type}`}>
                          {item.icon}
                        </span>
                        {item.text}
                      </li>
                    ))}
                  </ul>
                )}
                {currentTab.note && (
                  <p className="newhome-rules-note">{currentTab.note}</p>
                )}
              </>
            )}

          </div>
        </div>
      </section>



      {/* ===== ABOUT US ===== */}
      <section className="newhome-about" data-animate="fade-up">
        <img src={decorCornerOrnament} alt="" className="newhome-decor-corner-tl" loading="lazy" width="80" height="80" />
        <img src={decorCornerOrnament} alt="" className="newhome-decor-corner-br" loading="lazy" width="80" height="80" />
        <div className="newhome-about-inner">
          <div className="newhome-about-content">
            <h2 className="newhome-about-title">About us</h2>
            <p className="newhome-about-text">
              At Dreamland Entertainment, we believe that every event should be more than just an occasion—it should be an experience to remember. We are a passionate team dedicated to creating high-quality entertainment experiences that connect, inspire, and captivate audiences.
            </p>
            <p className="newhome-about-text">
              From large-scale concerts and live performances to corporate events and cultural showcases, we bring together creativity, strategic planning, and flawless execution. Every project we undertake is driven by attention to detail, innovative concepts, and a commitment to excellence.
            </p>
            <p className="newhome-about-text">
              Our goal is simple—to turn visions into unforgettable moments and deliver events that leave a lasting impact.
            </p>
          </div>
          <div className="newhome-about-logo">
            <img src={dleLogo} alt="DreamLand Entertainment" loading="lazy" width="200" height="200" />
          </div>
        </div>
      </section>

      {/* ===== PARTNERS SECTION ===== */}
      <section className="newhome-sponsors newhome-partners" style={{ padding: '20px 20px' }} data-animate="fade-up">
        <div className="newhome-sponsors-container">
          <h2 className="newhome-section-title">Our Partners</h2>

          <div className="newhome-sponsors-swiper-wrapper">
            <Swiper
              slidesPerView={4}
              spaceBetween={30}
              loop={true}
              speed={7000}
              autoplay={{
                delay: 0,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
              }}
              breakpoints={{
                1200: { slidesPerView: 4, spaceBetween: 30 },
                1024: { slidesPerView: 3, spaceBetween: 24 },
                768: { slidesPerView: 2, spaceBetween: 20 },
                0: { slidesPerView: 1.3, spaceBetween: 20 },
              }}
              modules={[Navigation, Autoplay]}
              className="newhome-sponsors-swiper"
              onSwiper={(swiper) => { partnersSwiperRef.current = swiper; }}
            >
              {partners.map((imgSrc, idx) => (
                <SwiperSlide key={idx}>
                  <div className="newhome-sponsor-card">
                    <div className="newhome-sponsor-card-inner">
                      <img
                        src={imgSrc}
                        alt="Partner"
                        className="newhome-sponsor-image"
                        loading="lazy"
                        width="150"
                        height="150"
                        style={{ 
                          transform: imgSrc === partner4 ? 'scale(2.2)' : 'none',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>


          </div>
        </div>
      </section>



    </div>

      {/* ===== PERFORMERS PROFILE MODAL ===== */}
      <Modal 
        show={showProfileModal} 
        onHide={() => setShowProfileModal(false)} 
        centered 
        size="xl"
        className="performers-profile-modal"
        scrollable
      >
        <Modal.Body className="profile-modal-body">
          <button className="profile-modal-close" onClick={() => setShowProfileModal(false)}>✕</button>
          <div className="profile-modal-header">
            <h2 className="profile-modal-title">Our Star Performers</h2>
            <div className="profile-modal-divider"></div>
          </div>
          <div className="profile-grid">
            {[
              { name: "SPB Charan", role: "Classic Icon", img: artSpbCharan },
              { name: "Anuradha Sriram", role: "Powerhouse", img: artAnuradhaSriram },
              { name: "Mukesh", role: "Star Performer", img: artMukesh },
              { name: "Priyanka NK", role: "Super Singer Star", img: artPriyanka },
              { name: "Hari Priya", role: "Viralvayyari", img: artHariPriya },
              { name: "Sam Vishal", role: "Youth Sensation", img: artSamVishal },
              { name: "VM Mahalingam", role: "Folk King", img: artMahalingam },
              { name: "Priya Jerson", role: "Vocal Talent", img: artPriyaJerson },
              { name: "Pooja Vaidhiyanathan", role: "Melody Queen", img: artPooja },
              { name: "Kaushik", role: "Sensational Voice", img: artKaushik },
              { name: "Ajay Krishna", role: "Rising Star", img: artAjayKrishna },
            ].map((p, idx) => (
              <div key={idx} className="profile-card">
                <div className="profile-card-img">
                  <img src={p.img} alt={p.name} />
                </div>
                <div className="profile-card-content">
                  <h3 className="profile-card-name">{p.name}</h3>
                  <p className="profile-card-role">{p.role}</p>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>

      {/* ===== COUPON OFFER POPUP ===== */}
      <Modal
        show={showCouponPopup}
        onHide={() => setShowCouponPopup(false)}
        centered
        className="coupon-popup-modal"
        backdropClassName="coupon-popup-backdrop"
      >
        <Modal.Body className="coupon-popup-body p-0">
          <button className="coupon-popup-close" onClick={() => setShowCouponPopup(false)}>✕</button>
          
          <div className="coupon-offers-wrapper">
            {/* Student Offer - Cart Style */}
            {/* <div className={`coupon-offer-item student-style ${activeOffer === 'student' ? 'active' : 'hidden'}`}>
              <div className="student-offer-layout">
                <div className="student-offer-img-side">
                  <img src={studentOfferImg} alt="Student Offer" />
                </div>
                <div className="student-offer-content-side">
                  <h4 className="student-offer-title">Student Special Offer!</h4>
                  <p className="student-offer-desc">
                    <strong style={{ color: '#EC6325', fontSize: '18px', display: 'block', marginBottom: '6px' }}>Buy 3 Get 1 FREE</strong>
                    Verify your student ID via WhatsApp to unlock this exclusive offer.
                  </p>
                  <a
                    href={`https://wa.me/${appSettings.phone || "919000000000"}?text=${encodeURIComponent("Hi, I am a student and would like to verify my student proof for the Buy 3 Get 1 Free offer.")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="student-offer-wa-btn"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                    VERIFY ON WHATSAPP
                  </a>
                </div>
              </div>
            </div> */}

            {/* Early Bird Offer - Cart Style */}
            <div className={`coupon-offer-item student-style ${activeOffer === 'early' ? 'active' : 'hidden'}`}>
              <div className="student-offer-layout">
                <div className="student-offer-img-side">
                  <img src={beat15Img} alt="Beat15 Offer" />
                </div>
                <div className="student-offer-content-side">
                  <h4 className="student-offer-title">Early Bird Special!</h4>
                  <p className="student-offer-desc">
                    <strong style={{ color: '#00d4ff', fontSize: '20px', display: 'block', marginBottom: '6px' }}>Flat 15% OFF</strong>
                    Apply this code at checkout to save on your booking.
                  </p>
                  <div className="coupon-popup-code-wrapper" style={{ margin: '15px 0' }}>
                    <div className="coupon-popup-code" onClick={() => { navigator.clipboard.writeText('BEAT15'); const el = document.querySelector('.coupon-popup-code'); if(el) { el.classList.add('copied'); setTimeout(() => el.classList.remove('copied'), 1500); } }}>
                      <span>BEAT15</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
                    </div>
                  </div>
                  <button className="coupon-popup-cta w-100" style={{ borderRadius: '8px', padding: '12px' }} onClick={() => { setShowCouponPopup(false); const el = document.getElementById('newhome-pricing-grid'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}>GRAB THE DEAL</button>
                  <p className="coupon-popup-terms" style={{ marginTop: '10px', fontSize: '11px', opacity: 0.8 }}>*Limited period offer. Tap the code to copy.</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HomeNew;
